/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  LocationDtoV2,
  LocationDtoV3,
  LocationDtoV4,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    LocationDtoV2FromJSON,
    LocationDtoV2ToJSON,
    LocationDtoV3FromJSON,
    LocationDtoV3ToJSON,
    LocationDtoV4FromJSON,
    LocationDtoV4ToJSON,
} from '../models';

export interface LocationByIdv5Request {
    id: string;
}

export interface LocationByIdv6Request {
    id: string;
}

export interface LocationByIdv7Request {
    id: number;
}

/**
 * 
 */
export class LocationControllerApi extends runtime.BaseAPI {

    /**
     */
    async locationByIdv5Raw(requestParameters: LocationByIdv5Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationDtoV2>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling locationByIdv5.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v5/locations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LocationDtoV2FromJSON(jsonValue));
    }

    /**
     */
    async locationByIdv5(requestParameters: LocationByIdv5Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationDtoV2> {
        const response = await this.locationByIdv5Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async locationByIdv6Raw(requestParameters: LocationByIdv6Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationDtoV3>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling locationByIdv6.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v6/locations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LocationDtoV3FromJSON(jsonValue));
    }

    /**
     */
    async locationByIdv6(requestParameters: LocationByIdv6Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationDtoV3> {
        const response = await this.locationByIdv6Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async locationByIdv7Raw(requestParameters: LocationByIdv7Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LocationDtoV4>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling locationByIdv7.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v7/locations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LocationDtoV4FromJSON(jsonValue));
    }

    /**
     */
    async locationByIdv7(requestParameters: LocationByIdv7Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LocationDtoV4> {
        const response = await this.locationByIdv7Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
